import userHttp from './userHttp';

const getUsers = (context) => {
  return new Promise((resolve, reject) => {
    userHttp.getUsers(context).then(response => {
      resolve(response.body);
    }, error => {
      reject(error);
    });
  });
};

const createUser = (context, user) => {
  return new Promise((resolve, reject) => {
    userHttp.createUser(context, user).then(response => {
      resolve(response.body);
    }, error => {
      reject(error);
    });
  });
};

const updateUser = (context, user) => {
  return new Promise((resolve, reject) => {
    userHttp.updateUser(context, user).then(response => {
      resolve(response.body);
    }, error => {
      reject(error);
    });
  });
};

const deleteUser = (context, id) => {
  return new Promise((resolve, reject) => {
    userHttp.deleteUser(context, id).then(response => {
      resolve(response.body);
    }, error => {
      reject(error);
    });
  });
};

const deleteMyAccount = (context, id) => {
  return new Promise((resolve, reject) => {
    userHttp.deleteMyAccount(context, id).then(response => {
      resolve(response.body);
    }, error => {
      reject(error);
    });
  });
};

const getPermissionUsers = (context) => {
  return new Promise((resolve, reject) => {
    userHttp.getUsers(context)
      .then(response => {
        resolve(formatToPermission(response.body));
      }, error => {
        reject(error);
      });
  });
};

const updateUserPassword = (context, request) => {
  return new Promise((resolve, reject) => {
    userHttp.updateUserPassword(context, request).then(() => {
      resolve();
    }, error => {
      reject(error);
    });
  });
};

const formatToPermission = users => {
  return users.map(user => ({
    label: user.name,
    value: {
      name: user.name,
      id: user.id,
      type: 'user',
      groups: user.groupIds
    }
  }));
};

const formatToEmailInfo = (user) => {
  return {
    'email': user.email,
    'isVerificated': user.emailVerificated,
    'id': user.id
  };
};

const getEmailInfoByName = (context) => {
  return new Promise((resolve, reject) => {
    userHttp.getEmailInfoByName(context)
      .then(response => {
        resolve(formatToEmailInfo(response.body));
      }, error => {
        reject(error);
      });
  });
};
const setEmailInfoByName = (context, request) => {
  return new Promise((resolve, reject) => {
    userHttp.setEmailInfoByName(context, request).then(() => {
      resolve();
    }, error => {
      reject(error);
    });
  });
};

const getUserProfile = (context, id) => {
  return new Promise((resolve, reject) => {
    userHttp.getUserProfile(context, id).then((data) => {
      resolve(data.body);
    }, error => {
      reject(error);
    });
  });
};
export default {
  getUsers,
  createUser,
  updateUser,
  deleteUser,
  deleteMyAccount,
  getPermissionUsers,
  updateUserPassword,
  getEmailInfoByName,
  setEmailInfoByName,
  getUserProfile
};



// WEBPACK FOOTER //
// ./src/api/user/index.js